import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ICompareFlightTooltipState } from '../../types/redux';

const initialState: ICompareFlightTooltipState = {
  isCompareFlightTooltipShow: false,
  isCompareFlightModalOpen: false,
};

export const compareFlightTooltipSlice = createSlice({
  name: 'compareFlightTooltip',
  initialState,
  reducers: {
    setCompareFlightModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCompareFlightModalOpen = action.payload;
    },
  },
});

export const {
  reducer: compareFlightTooltipReducer,
  actions: { setCompareFlightModalOpen },
} = compareFlightTooltipSlice;
